// extracted by mini-css-extract-plugin
module.exports = {"ListOfForumsRight":"px_a","ListOfForumsRight__brandDaysPosts":"px_b bhb_rq"};